import React from "react";
import {
    ArrayField,
    SimpleFormIterator,
    ReferenceField,
    TextField,
    Tab,
    FormTab,
    Datagrid,
    useTranslate,
    FormDataConsumer,
    useRecordContext,
    useGetOne,
    ReferenceInput,
    BooleanField,
    useResourceContext,
    required
} from 'react-admin';
import { Typography,Box, Divider, Chip } from '@mui/material';
import { ContentCopy } from "@mui/icons-material";
import { useFormContext } from 'react-hook-form';
import {
    CourseInstanceCreateLink,
    CourseInstanceLinkField
} from '../../../lib/CourseInstanceLink';
import {
    ArrayInput,
    AutocompleteInput,
    TextInput,
} from '../../../lib/wrappers/Inputs';
import { Button } from "../../../lib/wrappers/actions";
import { BooleanInput } from "../../../lib/wrappers/Inputs";
import { VersioningTypeInput } from "../../../lib/VersioningTypeInput";

var titleStyle = { color: "#AE223F" }
var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400, lineheight: 1, letterspacing: 0.00938
}

export const CourseDeliveriesInputTab = ({courseType, ...source}) => {
    const { setValue } = useFormContext();
    const record = useRecordContext();
    const resource = useResourceContext();
    const translate = useTranslate();
    // const MyLink = (props) => {
    //     const { label, courseCode, isAssociateCourse } = props;
    //     var link = '../#/CourseInstance?filter=%7B"q"%3A"' + code + '"%7D';
    
    //     return <a href={link}>Course Instances</a>
    // }

    const filter = () => {
        return {current: true};
    }
    return (
        <FormTab label="Course Deliveries" {...source}>
            <Box flex={4}  sx={{ paddingBottom: '20px' }}>
                <Typography variant="h6" style={titleStyle}>
                    Course | <small><TextField source="id" label={false} /></small> | <small><TextField source="courseCode" label={false} /></small>
                </Typography>
            </Box>
            <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '5px' }}><b style={labelStyle}><Chip sx={{fontSize: '1.2em'}} label="Course Deliveries"/></b></Divider>
            </Box>
        </Box>
        <ArrayInput source="courseDeliveries" label={false}>
            <SimpleFormIterator disableReordering fullWidth>
                <FormDataConsumer>
                    {({ formData, getSource, scopedFormData }) => {
                        const copyDeliveryClick = () => {
                            const copyOf =
                                formData.courseDeliveries.indexOf(
                                    scopedFormData
                                );
                            const courseDelivery = {
                                ...scopedFormData,
                                campusLocationId: null,
                                theDeliveryInstitutionID: null,
                                copyOf: copyOf,
                            };
                            setValue(
                                'courseDeliveries',
                                [
                                    ...formData.courseDeliveries,
                                    courseDelivery,
                                ],
                                { shouldDirty: true }
                            );
                        };

                        return (
                            <Box width={1}>
                                <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                    sx={{
                                        marginRight: '20px',
                                        marginTop: '5px',
                                    }}
                                >
                                    <Button 
                                        startIcon={<ContentCopy />}
                                        onClick={copyDeliveryClick}
                                    >
                                        {translate('myroot.copyDelivery')}
                                    </Button>
                                </Box>
                                <Box>
                                    <CourseInstanceCreateLink
                                        label="Create Instance"
                                        courseCode={record?.id}
                                        deliveryDetails={scopedFormData}
                                        source={getSource("id")}
                                    /> 
                                    <CourseInstanceLinkField
                                        label="Course Instances"
                                        source={scopedFormData}
                                        courseCode={record?.courseCode}
                                    />
                                </Box>
                            </Box>
                        );
                    }}
                </FormDataConsumer>

                <FormDataConsumer>
                    {({ getSource }) =>
                        <Box width={1}>
                            <Box display="flex">
                                <Box flex={2}>
                                    <ReferenceInput reference="Duration" source={getSource("durationId")}>
                                        <AutocompleteInput optionValue="id" optionText={(item) => item.Title} label="myroot.duration" fullWidth validate={required()} filter={filter()}/>
                                    </ReferenceInput>
                                </Box>
                                <Box flex={2} ml="0.5em">
                                    <ReferenceInput reference="ModeOfStudy" source={getSource("modeOfStudyId")}>
                                        <AutocompleteInput optionText="Title" fullWidth validate={required()} filter={filter()}/>
                                    </ReferenceInput>
                                </Box>
                                <Box flex={2} ml="0.5em">
                                    <ReferenceInput reference="ModeOfDelivery" source={getSource("modeOfDeliveryId")}>
                                        <AutocompleteInput optionText="Title" label="myroot.modeOfDelivery" fullWidth validate={required()} filter={filter()}/>
                                    </ReferenceInput>
                                </Box>
                                <Box flex={2} ml="0.5em">
                                    <ReferenceInput reference="CampusLocation" source={getSource("campusLocationId")}>
                                        <AutocompleteInput optionText="Title" label="myroot.campusLocation" fullWidth validate={required()} filter={filter()}/>
                                    </ReferenceInput>
                                </Box>
                            </Box>
                            <Box display="flex">
                                <Box flex={2}>
                                    <ReferenceInput reference="DeliveryInstitution" source={getSource("theDeliveryInstitutionID")}>
                                        <AutocompleteInput optionText="Title" label="myroot.deliveryInstitution" fullWidth validate={required()} filter={filter()}/>
                                    </ReferenceInput>
                                </Box>
                                <Box flex={2} ml="0.5em">
                                    <TextInput source={getSource("quercusCode")} fullWidth validate={required()} />
                                </Box>
                                <Box flex={2} ml="0.5em">
                                    <ReferenceInput reference="Status" source={getSource("statusId")}>
                                        <AutocompleteInput optionText="Title" fullWidth validate={required()} filter={filter()}/>
                                    </ReferenceInput>
                                </Box>
                                <Box flex={2} ml="0.5em">
                                    <BooleanInput source={getSource("shortCourse")} fullWidth />
                                </Box>
                            </Box>
                        </Box>
                    }
                </FormDataConsumer>
                <FormDataConsumer>
                    {({scopedFormData }) => {
                        const shortCourseValue = scopedFormData.shortCourse; 
                        if(scopedFormData.shortCourse == ""){
                            scopedFormData.shortCourse = false;
                        }
                        return null;
                    }}
                </FormDataConsumer>
            </SimpleFormIterator>
        </ArrayInput>
        {resource === "Course" &&
            <VersioningTypeInput source="versioningType" resource={resource} />
        }
    </FormTab>
    );
}

export const CourseDeliveriesShowTab = (source) => {
    const record = useRecordContext();
    return <Tab label="Course Deliveries" {...source}>
        <ArrayField source="courseDeliveries">
            <Datagrid>
                <ReferenceField reference="Duration" source="durationId" label="myroot.duration" linkType={<LinkToCourseInstances {...source} />}>
                    <TextField source="Title" />
                </ReferenceField>
                <ArrayField source="coursedeliveriesModeOfStudyIds" >
                    <Datagrid>
                        <ReferenceInput reference="ModeOfStudy" source="modeOfStudyId" >
                            <AutocompleteInput optionText="Title" />
                        </ReferenceInput>
                    </Datagrid>
                </ArrayField>
                <ReferenceField reference="ModeOfDelivery" source="modeOfDeliveryId" label="myroot.modeOfDelivery" link="show">
                    <TextField source="Title" />
                </ReferenceField>
                <ReferenceField reference="CampusLocation" source="campusLocationId" label="myroot.campusLocation" link="show">
                    <TextField source="Title" />
                </ReferenceField>
                <ReferenceField reference="DeliveryInstitution" source="theDeliveryInstitutionID" label="myroot.deliveryInstitution" link="show">
                    <TextField source="Title" />
                </ReferenceField>
                <TextField source="modeOfStudyId" />
                <TextField source="quercusCode" />
                <ReferenceField reference="Status" source="statusId">
                    <TextField source="Title" />
                </ReferenceField>
                <BooleanField source="shortCourse" sx={{ width: 1 / 4 }} />
                <CourseInstanceCreateLink label="Create Instance" courseCode={record?.id} />
                <CourseInstanceLinkField courseCode={record?.id} label="Course Instances" />
            </Datagrid>
        </ArrayField>

    </Tab>;
}

export const DeliveryRenderer = (myprops) =>
<div>
    Duration | &nbsp;
    <ReferenceField {...myprops} source="durationId" reference="Duration" label="myroot.duration" link={false}>
        <TextField source="Title" sx={{fontWeight: 'bold', fontSize: '1em'}} link={false}/>
    </ReferenceField>
    <br/>
    Mode Of Study | &nbsp;
    <ReferenceField {...myprops} source="modeOfStudyId" reference="ModeOfStudy" label="myroot.modeOfStudy"link={false}>
        <TextField source="Title" sx={{fontWeight: 'bold', fontSize: '1em'}} link={false}/>
    </ReferenceField>
    <br/>
    Mode of Delivery | &nbsp;
    <ReferenceField {...myprops} source="modeOfDeliveryId" reference="ModeOfDelivery" label="myroot.modeOfDelivery"link={false}>
        <TextField source="Title" sx={{fontWeight: 'bold', fontSize: '1em'}} link={false}/>
    </ReferenceField>
    <br/>
    Delivery Institution | &nbsp;
    <ReferenceField {...myprops} source="theDeliveryInstitutionID" reference="DeliveryInstitution"link={false}>
        <TextField source="Title" sx={{fontWeight: 'bold', fontSize: '1em'}} link={false}/>
    </ReferenceField>
    <br/>
    Campus Location | &nbsp;
    <ReferenceField {...myprops} source="campusLocationId" reference="CampusLocation"link={false}>
        <TextField source="Title" sx={{fontWeight: 'bold', fontSize: '1em'}} link={false}/>
    </ReferenceField>
</div>

const LinkToCourseInstances = (source) => {
    //Modifeing json to match 
    if (source == 'undefined' || source == null || source.record == 'undefined' || source.record == null) {
        return "";
    }

    var courseDeliveries = JSON.stringify(source.record).replace(/['"]+/g, "'").replace(/:/g, ": ").replace(/,/g, ", ")
    var CourseInstanceLink = "../#/CourseInstance?filter=%7B%22courseCode%22%3A%22" + source.id + "%22%2C%22courseDelivery%22%3A%22" + courseDeliveries + "%22%7D&order=DESC&page=1&perPage=10&sort=id";
    return <a href={CourseInstanceLink}>Course Instances </a>
};

const DeliverySelector = ({ courseId }) => {
    const {
        data: course,
        isLoading,
        error,
    } = useGetOne('Course', { id: courseId })};
